'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAddAPhoto = function MdAddAPhoto(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.3 23.4q0-2.3 1.6-3.9t3.7-1.5q2.3 0 3.9 1.5t1.5 3.9q0 2.1-1.5 3.7t-3.9 1.6-3.7-1.6-1.6-3.7z m5.3 8.2q3.5 0 5.9-2.4t2.5-5.8-2.5-5.9-5.9-2.5-5.8 2.5-2.4 5.9 2.4 5.8 5.8 2.4z m-11.6-15v-5h5v-5h11.6l3.1 3.4h5.3q1.3 0 2.3 1t1.1 2.4v20q0 1.3-1.1 2.3t-2.3 0.9h-26.6q-1.4 0-2.4-0.9t-1-2.3v-16.8h5z m-5-10v-5h3.4v5h5v3.4h-5v5h-3.4v-5h-5v-3.4h5z' })
        )
    );
};

exports.default = MdAddAPhoto;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/add-a-photo.js
// module id = 703
// module chunks = 36573943044255 79611799117203 213534597649335